import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import Mascot from "../components/Mascot";
import { useAuth } from "../context/AuthContext";
import { Zap, Trophy, Coins, Share2 } from "lucide-react";

export default function Landing() {
  const { user } = useAuth();
  const loggedIn = user && user !== false;
  return (
    <Layout hideNav>
      <section className="px-5 pt-8 pb-4 cb-pixel-bg">
        <div className="flex flex-col items-center text-center gap-5 cb-rise">
          <Mascot size={150} />
          <h1
            className="font-pixel text-[22px] leading-[1.35] text-glow-green"
            data-testid="landing-title"
          >
            CRYPTO
            <br />
            BOOM
          </h1>
          <p className="text-[#8b95a9] text-sm max-w-[280px]">
            Fly. Destroy blocks. Earn BOOM Credits. Convert to $UNI2 tokens on
            the UNI2Chain.
          </p>
          <div className="flex flex-col gap-3 w-full max-w-[260px]">
            <Link
              to={loggedIn ? "/game" : "/register"}
              data-testid="cta-play-btn"
              className="cb-neon-btn text-center"
            >
              ▶ {loggedIn ? "Play Now" : "Start Playing"}
            </Link>
            {!loggedIn && (
              <Link
                to="/login"
                data-testid="cta-login-btn"
                className="cb-neon-btn orange text-center"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      </section>

      <section className="px-5 py-6 grid grid-cols-2 gap-3">
        {[
          { key: "hybrid", icon: Zap, label: "Tap to fly, swipe to destroy", color: "#2ecc71" },
          { key: "credits", icon: Coins, label: "Earn BOOM Credits", color: "#f7931a" },
          { key: "leaderboard", icon: Trophy, label: "Climb global leaderboard", color: "#2e75b6" },
          { key: "referral", icon: Share2, label: "Share + refer to earn", color: "#ff6b00" },
        ].map((f, i) => {
          const Icon = f.icon;
          return (
            <div
              key={f.key}
              className="cb-card p-4 flex flex-col gap-2 cb-rise"
              style={{ animationDelay: `${0.1 * (i + 1)}s` }}
              data-testid={`landing-feature-${f.key}`}
            >
              <Icon size={20} style={{ color: f.color }} />
              <p className="text-[11px] text-white/80 leading-tight">
                {f.label}
              </p>
            </div>
          );
        })}
      </section>

      <section className="px-5 pb-10">
        <div className="cb-card p-5 flex flex-col gap-3">
          <h2 className="font-pixel text-[11px] text-[#f7931a] text-glow-gold">
            THE ECONOMY
          </h2>
          <p className="text-[12px] text-white/75">
            Earn <span className="text-[#2ecc71]">BOOM Credits (BC)</span> by
            playing, watching educational videos and completing social tasks.
            Convert BC to <span className="text-[#ff6b00]">UNI2 Tokens</span>.
          </p>
          <div className="grid grid-cols-2 gap-3 text-center mt-2">
            <div className="p-3 rounded-[8px] border border-[rgba(247,147,26,0.45)] bg-[rgba(247,147,26,0.06)]">
              <div className="font-pixel text-[10px] text-[#f7931a]">EARLY</div>
              <div className="font-pixel text-[11px] text-white mt-1">
                500 BC = 1 UNI2
              </div>
            </div>
            <div className="p-3 rounded-[8px] border border-[rgba(46,117,182,0.5)] bg-[rgba(46,117,182,0.06)]">
              <div className="font-pixel text-[10px] text-[#2e75b6]">LATER</div>
              <div className="font-pixel text-[11px] text-white mt-1">
                1000 BC = 1 UNI2
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
